import {
  Component,
  Output,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Transaction } from '../../transaction-store/transaction';

const customValueProvider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectFieldComponent),
  multi: true
};
@Component({
  selector: 'select-field',
  template: `
    <div
      [ngClass]="{
        'validation-failed':
          (showValidation || isTouched) && required && (!model || model == '')
      }"
      [floatingLabel]="model"
      [focus]="focused"
    >
      <label>{{ label + (required ? '*' : '') }}</label>
      <ng-select
        #select
        placeholder="{{ label + (required ? ' *' : '') }}"
        class="w-100 custom"
        [items]="items"
        bindLabel="text"
        bindValue="val"
        [(ngModel)]="model"
        (ngModelChange)="onChange($event)"
        [loading]="loading || false"
        [typeahead]="typeahead"
        [closeOnSelect]="true"
        (change)="onBlur($event)"
        (close)="focusOther()"
        (search)="onSearch($event)"
        [required]="required"
        [clearable]="clearable"
        [searchable]="searchable"
        [searchFn]="searchFn"
      >
        <ng-template ng-label-tmp let-item="item">
          <span [title]="item.hasOwnProperty('text') ? item.text : item">
            {{ item.hasOwnProperty('text') ? item.text : item }}
          </span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div [title]="item.hasOwnProperty('text') ? item.text : item">
            {{ item.hasOwnProperty('text') ? item.text : item }}
          </div>
        </ng-template>
      </ng-select>
    </div>
  `,
  providers: [customValueProvider]
})
export class SelectFieldComponent implements ControlValueAccessor, OnInit {

  constructor() {}
  @ViewChild('select', { static: true }) currentSelectField;
  @Input() items;
  model;
  @Input() label;
  @Input() loading;
  @Input() typeahead;
  focused;
  isTouched;
  @Input() showValidation = false;
  @Input() required;
  @Input() clearable = false;

  @Input() searchable = true;
  @Input() searchFn = undefined;

  @Output() blur = new EventEmitter<string>();
  @Output() search = new EventEmitter<string>();
  disabled;

  @Select() transaction$: Observable<Transaction>;
  touched = $event => {};
  onChange = $event => {};

  ngOnInit() {
    this.transaction$.subscribe(item => {
      this.showValidation = item.validation;
    });
  }

  onBlur($event) {
    this.isTouched = true;
    this.setFocused(false);
    this.blur.emit(this.model);
    this.touched($event);
  }

  onSearch($event) {
    this.search.emit($event);
  }

  setFocused(focus) {
    this.focused = focus;
  }

  writeValue(obj) {
    this.model = obj;
    setTimeout(() => {
      this.currentSelectField.close();
    }, 10);
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.touched = fn;
  }

  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
  // in iOS when an input is focused, the native keyboard opens up
  // automatically even when the user has already selected an item
  // this will blur the input fields so the keyboard closes
  focusOther() {
    setTimeout(() => {
      let inputs = <HTMLScriptElement[]>(
        (<any>document.querySelectorAll('ng-select input'))
      );
      inputs = Array.prototype.slice.call(inputs); // https://github.com/babel/babel/issues/6511
      inputs.forEach(input => {
        (input as HTMLElement).blur();
      });
    }, 10);
  }
}
